"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toString = toString;
exports.EMPTY_TOSTRING = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _toStringForType;

var EMPTY_TOSTRING = '-';
exports.EMPTY_TOSTRING = EMPTY_TOSTRING;
var toStringForType = (_toStringForType = {}, (0, _defineProperty2.default)(_toStringForType, _ObjectTypes.VISIT, function (record) {
  return (0, _ObjectRecordAccessors.getProperty)(record, 'name') || (0, _ObjectRecordAccessors.getProperty)(record, 'domain') || EMPTY_TOSTRING;
}), (0, _defineProperty2.default)(_toStringForType, _ObjectTypes.CONTACT, function (record, nameFormatter) {
  var firstName = (0, _ObjectRecordAccessors.getProperty)(record, 'firstname');
  var lastName = (0, _ObjectRecordAccessors.getProperty)(record, 'lastname');
  var displayName = nameFormatter({
    firstName: firstName,
    lastName: lastName
  }) || (0, _ObjectRecordAccessors.getProperty)(record, 'email');
  return displayName || '-';
}), _toStringForType);

function toStringByType(objectType, record, nameFormatter) {
  (0, _invariant.default)(Object.prototype.hasOwnProperty.call(toStringForType, objectType), 'ImmutableModel: toString not defined for objectType "%s"', objectType);
  return toStringForType[objectType](record, nameFormatter);
}

function toString(nameFormatter, record) {
  if (Object.prototype.hasOwnProperty.call(toStringForType, (0, _ObjectRecordAccessors.getObjectType)(record))) {
    return toStringByType((0, _ObjectRecordAccessors.getObjectType)(record), record, nameFormatter);
  }

  if (typeof record.constructor.toString === 'function') {
    return record.constructor.toString(record);
  }

  return toStringByType((0, _ObjectRecordAccessors.getObjectType)(record), record, nameFormatter);
}